import {
    Box,
    Flex,
    VStack,
    HStack,
    Text,
    Spinner,
} from "@chakra-ui/react";

import {
    Bell,
    Settings,
    CreditCard,
    TriangleAlert,
} from "lucide-react";

import {
    useEffect,
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";
import PageHeader from "../Dashboard/components/PageHeader";

import {
    getNotifications,
    markNotificationRead,
} from "../../state/actions/notificationActions";
import getIconConfig from "./components/IconConfig";

const Notifications = () => {
    const dispatch =
        useDispatch();

    const {
        notifications = [],
        loading,
    } = useSelector(
        state =>
            state.notifications
    );

    useEffect(() => {
        dispatch(
            getNotifications(
                null,
                null,
                1,
                100
            )
        );
    }, [
        dispatch,
    ]);



    const handleNotificationClick =
        async (
            notification
        ) => {
            if (
    notification.read_status !==
    "Read"
) {
                await dispatch(
                    markNotificationRead(
                        notification.notification_id
                    )
                );
            }
        };

    return (
        <Flex
            h="100vh"
            bg="#F8FAFC"
            overflow="hidden"
        >
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <PageHeader
                        title="Notifications"
                        subtitle="View all system alerts, updates and account activity."
                    />

                    {loading ? (
                        <Flex
                            py={20}
                            justify="center"
                            align="center"
                        >
                            <Spinner color="#2453FF"/>

                            <Text ml={3}>
                                Loading notifications...
                            </Text>
                        </Flex>
                    ) : notifications.length === 0 ? (
                        <Flex
                            py={20}
                            justify="center"
                        >
                            <Text
                                color="gray.500"
                            >
                                No notifications found.
                            </Text>
                        </Flex>
                    ) : (
                        <VStack
                            gap={4}
                            align="stretch"
                        >
                            {notifications.map(
                                notification => {
                                    const config =
                                        getIconConfig(
                                            notification
                                        );

                                    const Icon =
                                        config.icon;

                                    return (
                                        <Flex
                                            key={
                                                notification.notification_id
                                            }
                                            p={6}
                                            bg={
    notification.read_status ===
    "Read"
        ? "white"
        : "#F8FAFC"
}
                                            borderRadius="20px"
                                            gap={4}
                                            cursor="pointer"
                                            onClick={() =>
                                                handleNotificationClick(
                                                    notification
                                                )
                                            }
                                        >
                                            <Flex
                                                w="52px"
                                                h="52px"
                                                borderRadius="16px"
                                                bg={
                                                    config.bg
                                                }
                                                justify="center"
                                                align="center"
                                                flexShrink={0}
                                            >
                                                <Icon
                                                    size={22}
                                                    color={
                                                        config.color
                                                    }
                                                />
                                            </Flex>

                                            <Box flex="1">
                                                <HStack
                                                    justify="space-between"
                                                    mb={2}
                                                    align="start"
                                                >
                                                    <Text
                                                        fontSize="xs"
                                                        fontWeight="700"
                                                        color={
                                                            config.color
                                                        }
                                                        letterSpacing="1px"
                                                    >
                                                        {
                                                            notification.category ||
                                                            notification.notification_type ||
                                                            "SYSTEM"
                                                        }
                                                    </Text>

                                                    <Text
                                                        fontSize="sm"
                                                        color="gray.500"
                                                    >
                                                        {
                                                            notification.created_at
                                                        }
                                                    </Text>
                                                </HStack>

                                                <Text
                                                    fontWeight="700"
                                                    mb={2}
                                                    color="#071D54"
                                                >
                                                    {
                                                        notification.title
                                                    }
                                                </Text>

                                                <Text
                                                    color="gray.600"
                                                    lineHeight="1.7"
                                                >
                                                    {
                                                        notification.message ||
                                                        notification.description
                                                    }
                                                </Text>
                                            </Box>
                                        </Flex>
                                    );
                                }
                            )}
                        </VStack>
                    )}
                </Box>
            </Flex>
        </Flex>
    );
};

export default Notifications;